import React, { useState, useEffect } from 'react'

import { Icon, Search as SearchIcon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import { useSearch } from 'Pods/UnifiedNavigation/Hooks/useSearch'

import ImageSearch from './Components/ImageSearch/ImageSearch'
import SuggestionRow from './Components/SuggestionRow/SuggestionRow'

function Search({
  isInListingPage,
  searchInputValue = '',
  searchPlaceholder,
  locale = 'en',
}) {
  const {
    query,
    wrapperRef,
    suggestions,
    showSuggestions,
    onInputChange,
    handleKeyDown,
    submitting,
    handleSubmit,
    cursorPosition,
  } = useSearch(isInListingPage, searchInputValue)
  // Below 390px the design shows a short "Search" placeholder; CSS cannot swap
  // placeholder text, so track the breakpoint and switch it in place.
  const [isCompact, setIsCompact] = useState(false)
  const t = (key) => i18n.t(key, { ns: 'rails', lng: locale })

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 389px)')
    const handleChange = () => setIsCompact(mediaQuery.matches)

    handleChange()
    mediaQuery.addEventListener('change', handleChange)

    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return (
    <div className="unified-nav__search" ref={wrapperRef}>
      <form
        className="unified-nav__search-form"
        id="nav-search-form"
        acceptCharset="UTF-8"
        action="/search"
        method="get"
        onSubmit={handleSubmit}
      >
        <div className="unified-nav__field">
          <input
            type="text"
            name="keywords"
            className="unified-nav__field-input cgt-body-md"
            placeholder={isCompact ? t('navigation.aria.search') : searchPlaceholder}
            autoComplete="off"
            value={query}
            onChange={onInputChange}
            onKeyDown={handleKeyDown}
          />
          <ImageSearch locale={locale} />
          <button
            type="submit"
            className="unified-nav__field-submit"
            aria-label={t('navigation.aria.search')}
          >
            {submitting ? (
              <span className="unified-nav__field-spinner" />
            ) : (
              <Icon notSpaced svgComponent={SearchIcon} size="small" color="light" />
            )}
          </button>
        </div>
      </form>

      {/* Portal target for the listing "Filters" trigger (RemainingFilters),
          pushed in from ListingPage.jsx below md. Empty here by design. */}
      {isInListingPage && (
        <div className="unified-nav__filters-slot js-remaining-filters" />
      )}

      {suggestions.length > 0 && showSuggestions && (
        <div className="unified-nav__suggestions">
          <ul className="unified-nav__suggestions-list">
            {suggestions.map((resultRow, i) => (
              <li key={resultRow[0]}>
                <SuggestionRow
                  query={query}
                  result={resultRow[0]}
                  thumbnailUrl={resultRow[1].thumbnailUrl}
                  className={i === cursorPosition ? 'is-active' : ''}
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

Search.propTypes = {
  isInListingPage: bool.isRequired,
  searchInputValue: string,
  searchPlaceholder: string.isRequired,
  locale: string,
}

export default Search
